import * as yup from "yup";
import {
  validateNoHandTypedVariables,
  validateTemplateBody,
  validateTemplateExamples,
} from "../../../../../utils/templateBodyValidation";
import { TEMPLATE_BUTTON_TYPE, TEMPLATE_CATEGORY } from "../constants/template";

export const templateSchema = yup.object().shape({
  templateName: yup
    .string()
    .required("El nombre de la plantilla es requerido")
    .min(3, "El nombre de la plantilla debe tener al menos 3 caracteres")
    .max(50, "El nombre de la plantilla debe tener menos de 50 caracteres")
    .test(
      "",
      "El nombre no debe iniciar o terminar con guion bajo (_)",
      (value) => {
        if (!value) return true;

        return !/^_/.test(value) && !/_$/.test(value);
      },
    ),

  templateCategory: yup
    .string()
    .required("La categoría de la plantilla es requerida")
    .oneOf(
      [TEMPLATE_CATEGORY.MARKETING, TEMPLATE_CATEGORY.UTILITY],
      "Categoría no válida",
    ),

  // `templateVariables` is not a visible field: the form keeps the examples of
  // the body variables there (one per `{{n}}`, in order) so the body rule can
  // check that every variable has one. Meta creates a template with a variable
  // that has no example already rejected.
  // `bodyText` is not visible either: it is the editor's visible text, where a
  // field shows as its example word, so braces typed by hand are the only
  // `{{…}}` left. They are blocked first (the author never types a variable).
  // Without `bodyText` there is nothing to inspect and the rule is skipped.
  bodyMessage: yup.mixed().test("canonical-body", function (value) {
    const handTyped = validateNoHandTypedVariables(
      this.parent.bodyText,
      "campaign",
    );
    if (!handTyped.valid)
      return this.createError({ message: handTyped.message });
    const result = validateTemplateBody(value);
    if (!result.valid) return this.createError({ message: result.message });
    const examples = validateTemplateExamples(
      result.normalized,
      this.parent.templateVariables,
    );
    return examples.valid || this.createError({ message: examples.message });
  }),

  footerMessage: yup
    .string()
    .transform((value) => {
      // Convertir strings vacíos o solo espacios a undefined
      return value && value.trim() !== "" ? value.trim() : undefined;
    })
    .min(5, "El pie de página debe tener al menos 5 caracteres")
    .max(50, "El pie de página debe tener menos de 50 caracteres")
    .matches(
      /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ,.-]+$/,
      "El pie de página no puede contener emojis o caracteres especiales",
    )
    .optional()
    .nullable(),

  isAddMultimedia: yup.boolean().optional(),

  buttons: yup
    .array()
    .of(
      yup.object().shape({
        text: yup
          .string()
          .max(25, "El texto del botón debe tener menos de 25 caracteres")
          .matches(
            /^[a-zA-Z0-9ñÑ.,\-/\s]+$/,
            "El texto contiene caracteres no válidos",
          )
          .required("El texto del botón es requerido"),
        type: yup
          .string()
          .oneOf([TEMPLATE_BUTTON_TYPE.QUICK_REPLY], "Tipo de botón no válido")
          .required("El tipo de botón es requerido"),
      }),
    )
    .max(3, "Se pueden agregar hasta 3 botones")
    .test(
      "unique-buttons",
      "Los botones no pueden tener el mismo texto",
      (value) => {
        if (!value || value.length <= 1) return true;

        const texts = value
          .map((b) => b.text && b.text.trim().toLowerCase())
          .filter((t) => t);

        const uniqueTexts = new Set(texts);

        return uniqueTexts.size === texts.length;
      },
    )
    .optional(),
});
